import { useSpring, animated } from "@react-spring/web";
import { useState } from "react";
import { AnimationOnAppear } from "./AnimationOnAppear";

interface Props {
  value: number;
  className?: string;
  unit?: string;
  runOn?: "mount" | "appear";
}

export function NumberAnimation({
  value,
  unit = "",
  runOn = "mount",
  ...props
}: Props) {
  const [isAnimating, startAnimate] = useState(runOn === "mount");

  const { number } = useSpring({
    from: { number: 0 },
    number: isAnimating ? value : 0,
    delay: 200,
    config: {
      mass: 1,
      tension: 20,
      friction: 10,
    },
  });

  return (
    <AnimationOnAppear
      onStartAnimation={() => startAnimate(true)}
      noAnimationDuringDelay
    >
      <animated.div {...props} style={{ whiteSpace: "nowrap" }}>
        {number.to((n) => n.toFixed(0) + unit)}
      </animated.div>
    </AnimationOnAppear>
  );
}
